import React, { useState } from "react";
import { Layout, Select } from "antd";
import SiderComponent from "./../components/SiderComponent";
import HeaderComponent from "./../components/HeaderComponent";

// Existing deal components (UNCHANGED)
import Sonstige from "./Sonstige";
import EarlyBird from "./EarlyBird";
import Edu from "./Edu";
import MemberDeal from "./MemberDeal";
import GreenfeeCards from "./GreenfeeCards";
import GreenfeeAbkommen from "./GreenfeeAbkommen";
import Aufschlaege from "./Aufschlaege";

const { Content } = Layout;
const { Option } = Select;

/**
 * DealsUnified
 * -----------------------------
 * This component ONLY unifies the UI using a dropdown.
 * All existing deal components, logic, fields, and APIs remain untouched.
 */
function DealsUnified(props) {
  const [selectedDeal, setSelectedDeal] = useState("edu");

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <SiderComponent props={props} />
      <Layout>
        <HeaderComponent />

        <Content
          style={{
            backgroundColor: "#EAEAEA",
            padding: 50,
          }}
        >
          {/* <h3 style={{ marginTop: 30 }}>Deals</h3> */}

          {/* DEAL TYPE DROPDOWN */}
          <div
            style={{
              backgroundColor: "white",
              borderRadius: 15,
              padding: 20,
              marginTop: 20,
              width: 400,
            }}
            className="create-top-deals-form"
          >
            <Select
              value={selectedDeal}
              onChange={setSelectedDeal}
              style={{ width: "100%" }}
              size="middle"
              className="dropdown-clsn-dealunited"
            >
              <Option value="edu">Student & Youth</Option>
              <Option value="earlyBird">Early Bird / Sundowner</Option>
              <Option value="greenfeeabkommen">Green fee agreement</Option>
              <Option value="cards">Discount Cards</Option>
              <Option value="sonstige">Other</Option>
              <Option value="member">Member Guest</Option>
              <Option value="surcharge">VcG & Fernmitglied</Option>
            </Select>
          </div>

          {/* DEAL SECTIONS (UNCHANGED COMPONENTS) */}
          <div style={{ marginTop: 30 }}>
            {selectedDeal === "edu" && <Edu {...props} />}
            {selectedDeal === "earlyBird" && <EarlyBird {...props} />}
            {selectedDeal === "greenfeeabkommen" && (
              <GreenfeeAbkommen {...props} />
            )}
            {selectedDeal === "cards" && <GreenfeeCards {...props} />}
            {selectedDeal === "sonstige" && <Sonstige {...props} />}
            {selectedDeal === "member" && <MemberDeal {...props} />}
            {selectedDeal === "surcharge" && <Aufschlaege {...props} />}
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default DealsUnified;
